import React, { useRef, useEffect } from 'react';
import QRCode from 'qrcode';
import Modal from '../../components/modal';

import styles from './index.module.css';
import { useAtom } from 'jotai';
import { visibleInvoicingAtom } from '@/store';
import { useLocaleStore } from '@/i18n/localeStore';

const InvoicingModal = () => {
  const { $t } = useLocaleStore();
  const { toCanvas } = QRCode;
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const [visibleInvoicing, setVisibleInvoicing] = useAtom(visibleInvoicingAtom);

  const initQrcode = () => {
    if (canvasRef.current) {
      const accessToken = window.localStorage.getItem('access_token') || '';
      const env = process.env.REACT_APP_ENV;
      const url =
        env === 'beta'
          ? 'https://beta-payment-invoice.meitu.com/home'
          : env === 'release'
          ? 'https://payment-invoice.meitu.com/home'
          : 'https://pre-payment-invoice.meitu.com/home';
      const appID = 'com.meitu.mtxxpro';
      const params = `appID=${encodeURIComponent(appID)}&token=${accessToken}`;
      console.log(`${url}?${params}`);
      toCanvas(
        canvasRef.current,
        `${url}?${params}`,
        {
          width: 176,
          margin: 1,
        },
        function (error) {
          if (error) console.error(error);
          console.log('success!');
        }
      );
    }
  };

  useEffect(() => {
    // 打印环境变量
    console.log(process.env.REACT_APP_ENV);
    if (visibleInvoicing) {
      setTimeout(() => {
        initQrcode();
      }, 0);
    }
  }, [visibleInvoicing]);

  const applyName = '美图设计室';

  return (
    <Modal
      visible={visibleInvoicing}
      onClose={() => setVisibleInvoicing(false)}
      style={{
        backgroundColor: '#181A1C',
        width: '406px',
        minHeight: '374px',
        height: 'auto',
      }}
    >
      <div className={styles.title}>{$t((v) => v.Title_ScanToInvoice)}</div>
      <div className={styles.qrcodeWrap}>
        <canvas ref={canvasRef}></canvas>
      </div>
      <div className={styles.divide}></div>
      <div className={styles.footer}>
        <div className={styles.left}>
          <div className={styles.qrcode}></div>
        </div>
        <div className={styles.right}>
          {$t((v, { r }) => r(v.Text_InvoiceLink, [applyName]))}
          <br />
          {$t((v) => v.Text_InvoiceOtherBusiness)}
        </div>
      </div>
    </Modal>
  );
};

export default InvoicingModal;
